import { Flex } from "@similarweb/ui-components/foundations";

import { useIsFocusedState } from "../../hooks/useIsFocusedState";

import { StyledAIAgentChatControls } from "./styles";

export type AIAgentPromptGroupProps = {
    value: string;
    isInputLocked: boolean;
    isSubmitLocked: boolean;
    isFocusTriggered: boolean;
    placeholder: string;
    onChange: (value: string) => void;
    onSubmit: VoidFunction;
};

const AIAgentPromptGroup = ({
    value,
    isInputLocked,
    isSubmitLocked,
    isFocusTriggered,
    placeholder,
    onChange,
    onSubmit,
}: AIAgentPromptGroupProps) => {
    const [isFocused] = useIsFocusedState(isFocusTriggered);

    return (
        <Flex
            data-automation="ai-agent-prompt-group"
            gap="8px"
            alignItems="center"
        >
            <StyledAIAgentChatControls
                text={value}
                isInputLocked={isInputLocked}
                isSubmitLocked={isSubmitLocked}
                isFocused={isFocused}
                placeholder={placeholder}
                onSubmit={onSubmit}
                onChange={onChange}
            />
        </Flex>
    );
};

export default AIAgentPromptGroup;
